<template>
<div class="header">
  <div class="header-left">
    <div class="logo">
      <img src="../../assets/LOGO.png">
      <div class="line"></div>
    </div>

    <a href="/#/login" v-show="flag=='patient'"><span>{{ $t('title') }}</span></a>
    <a href="/#/hcpLogin" v-show="flag=='hcp'"><span>{{ $t('title1') }}</span></a>
    <a href="/#/accountsmanagement" v-show="flag=='accountsmanagement'"><span>EasyView Accounts Managment</span></a>
    <a href="/#/clinic" v-show="flag=='clinic'"><span>EasyView Clinic</span></a>

  </div>
  <div class="header-right"  @click="languageFormVisible = true" v-show="showCountry">
    <img v-show="this.$store.state.country[0]" src="../../assets/England.png">
    <img v-show="this.$store.state.country[1]" src="../../assets/China.png">
    <img v-show="this.$store.state.country[2]" src="../../assets/France.png">
    <img v-show="this.$store.state.country[3]" src="../../assets/German.png">
    <img v-show="this.$store.state.country[4]" src="../../assets/Sweden.png">
    <img v-show="this.$store.state.country[5]" src="../../assets/Australia.png">
    <img v-show="this.$store.state.country[6]" src="../../assets/Hongkong.png">
    <img v-show="this.$store.state.country[7]" src="../../assets/Hungary.png">
    <img v-show="this.$store.state.country[8]" src="../../assets/Italy.png">
    <img v-show="this.$store.state.country[9]" src="../../assets/Netherlands.png">
    <img v-show="this.$store.state.country[10]" src="../../assets/Norway.png">
    <img v-show="this.$store.state.country[11]" src="../../assets/Page 1.png">
    <img v-show="this.$store.state.country[12]" src="../../assets/Spain.png">
    <img v-show="this.$store.state.country[13]" src="../../assets/Turkey.png">
    <img v-show="this.$store.state.country[14]" src="../../assets/Uniited Arab Emirates.png">
    <img v-show="this.$store.state.country[15]" src="../../assets/Romania.png">
    <img v-show="this.$store.state.country[16]" src="../../assets/Czech republic.png">
    <img v-show="this.$store.state.country[17]" src="../../assets/Slovenska republika.png">
    <img v-show="this.$store.state.country[18]" src="../../assets/Lithuania.png">
    <img v-show="this.$store.state.country[19]" src="../../assets/Polska.png">
    <img v-show="this.$store.state.country[20]" src="../../assets/Danmark.png">
    <img v-show="this.$store.state.country[21]" src="../../assets/Suomi.png">
    <img v-show="this.$store.state.country[22]" src="../../assets/Thailand.png">
    <img v-show="this.$store.state.country[23]" src="../../assets/Indonesia.png">
    <img v-show="this.$store.state.country[24]" src="../../assets/Malaysia.png">
    <img v-show="this.$store.state.country[25]" src="../../assets/India.png">
    <!-- 2018.7.31 增加 -->
    <img v-show="this.$store.state.country[26]" src="../../assets/Switzerland.png">
    <img v-show="this.$store.state.country[27]" src="../../assets/Saudi_Arabia.png">
    <img v-show="this.$store.state.country[28]" src="../../assets/Uniited_Arab_Emirates.png">
    <img v-show="this.$store.state.country[29]" src="../../assets/Qatar.png">
    <img v-show="this.$store.state.country[30]" src="../../assets/Kuwait.png">
    <!-- 2020.1.2 增加 -->
    <img v-show="this.$store.state.country[31]" src="../../assets/flags/Croatia.png">
    <img v-show="this.$store.state.country[32]" src="../../assets/flags/Austria.png">
    <img v-show="this.$store.state.country[33]" src="../../assets/flags/Slovenia.png">
    <img v-show="this.$store.state.country[34]" src="../../assets/flags/Estonia.png">
    <img v-show="this.$store.state.country[35]" src="../../assets/flags/Latvia.png">
    <img v-show="this.$store.state.country[36]" src="../../assets/flags/BIH.png">
    <img v-show="this.$store.state.country[37]" src="../../assets/flags/Bulgaria.png">
    <img v-show="this.$store.state.country[38]" src="../../assets/flags/Chile.png">
    <img v-show="this.$store.state.country[39]" src="../../assets/flags/Belgium.png"> <!-- 比利时， 2020.3.16增加 -->

    <span v-show="this.$store.state.langs[0].lang">English</span>
    <span v-show="this.$store.state.langs[1].lang">中文</span>
    <span v-show="this.$store.state.langs[2].lang">France</span>
    <span v-show="this.$store.state.langs[3].lang">German</span>
    <span v-show="this.$store.state.langs[4].lang">Sweden</span>
    <span v-show="this.$store.state.langs[5].lang">English</span>
    <span v-show="this.$store.state.langs[6].lang">繁体中文</span>
    <span v-show="this.$store.state.langs[7].lang">English</span>
    <span v-show="this.$store.state.langs[8].lang">Italian</span>
    <span v-show="this.$store.state.langs[9].lang">Dutch</span>
    <span v-show="this.$store.state.langs[10].lang">English</span>
    <span v-show="this.$store.state.langs[11].lang">Portuguese</span>
    <span v-show="this.$store.state.langs[12].lang">Spanish</span>
    <span v-show="this.$store.state.langs[13].lang">Türkçe</span>
    <span v-show="this.$store.state.langs[14].lang">English</span>
    <span v-show="this.$store.state.langs[15].lang">English</span>
    <span v-show="this.$store.state.langs[16].lang">Czech</span>
    <span v-show="this.$store.state.langs[17].lang">English</span>
    <span v-show="this.$store.state.langs[18].lang">English</span>
    <span v-show="this.$store.state.langs[19].lang">Polski</span>
    <span v-show="this.$store.state.langs[20].lang">Dansk</span>
    <span v-show="this.$store.state.langs[21].lang">Suomi</span>
    <span v-show="this.$store.state.langs[22].lang">English</span>
    <span v-show="this.$store.state.langs[23].lang">English</span>
    <span v-show="this.$store.state.langs[24].lang">English</span>
    <span v-show="this.$store.state.langs[25].lang">English</span>

    <!-- 2018.7.31增加 -->
    <span v-show="this.$store.state.langs[26].lang">English</span>
    <span v-show="this.$store.state.langs[27].lang">English</span>
    <span v-show="this.$store.state.langs[28].lang">English</span>
    <span v-show="this.$store.state.langs[29].lang">English</span>
    <span v-show="this.$store.state.langs[30].lang">English</span>
    <!-- 2020.1.2 增加 -->
    <span v-show="this.$store.state.langs[31].lang">English</span>
    <span v-show="this.$store.state.langs[32].lang">English</span>
    <span v-show="this.$store.state.langs[33].lang">English</span>
    <span v-show="this.$store.state.langs[34].lang">English</span>
    <span v-show="this.$store.state.langs[35].lang">English</span>
    <span v-show="this.$store.state.langs[36].lang">English</span>
    <span v-show="this.$store.state.langs[37].lang">English</span>
    <span v-show="this.$store.state.langs[38].lang">English</span>
    <span v-show="this.$store.state.langs[39].lang">English</span>

  </div>
  <!--语言选择框-->
  <el-dialog  :visible.sync="languageFormVisible" :size=dialogSize  id="language-choose" :show-close="false" top="10%">
    <div slot="title" class="language-choose-title">
      <span>{{ $t('chooseLang')}}</span>
      <img src="../../assets/cancel.png" @click="cancelChoose">
    </div>
    <div slot class="language-choose-body">
      <div class="language-group">
         <label>{{ $t('asia') }}</label>
         <hr class="language-form-hr">
        <div class="language">
          <img src="../../assets/Australia.png"><span >Australia -<label @click="languageChoose(5,0)">English</label></span>
        </div>
         <div class="language zhType">
           <img src="../../assets/China.png"><span >中国 -<label @click="languageChoose(1,1)">中文简体</label></span>
         </div>
        <div class="language speLang2">
          <img src="../../assets/Hongkong.png"><span >香港 (中国) -<label @click="languageChoose(6,6)">繁体中文</label></span>
        </div>
        <!--
        <div class="language">
          <img src="../../assets/Uniited Arab Emirates.png"><span>United Arab Emirates -<label @click="languageChoose(14,0)">English</label></span>
        </div>-->
        <div class="language">
          <img src="../../assets/Thailand.png"><span>Thailand -<label @click="languageChoose(22,0)">English</label></span>
        </div>
        <div class="language">
          <img src="../../assets/Indonesia.png"><span>Indonesia -<label @click="languageChoose(23,0)">English</label></span>
        </div>
        <div class="language">
          <img src="../../assets/Malaysia.png"><span>Malaysia -<label @click="languageChoose(24,0)">English</label></span>
        </div>
        <div class="language">
          <img src="../../assets/India.png"><span>India -<label @click="languageChoose(25,0)">English</label></span>
        </div>
      </div>
      <div class="language-group">
        <label>{{ $t('europe') }}</label>
        <hr class="language-form-hr">
        <div class="language">
          <img src="../../assets/France.png">
          <span >France -<label @click="languageChoose(2,0)">English</label><label @click="languageChoose(2,2)">France</label></span>
        </div>
        <div class="language speLang3">
          <img src="../../assets/German.png">
          <span>Deutschland -<label @click="languageChoose(3,0)">English</label><label @click="languageChoose(3,3)">German</label></span>
        </div>
        <div class="language">
          <img src="../../assets/Hungary.png"><span >Magyarország -<label @click="languageChoose(7,0)">English</label></span>
        </div>
        <div class="language">
          <img src="../../assets/Italy.png">
          <span >Italia -<label @click="languageChoose(8,0)">English</label><label @click="languageChoose(8,8)">Italian</label></span>
        </div>
        <div class="language">
          <img src="../../assets/Netherlands.png">
          <span >Nederland -<label @click="languageChoose(9,0)">English</label><label @click="languageChoose(9,9)">Dutch</label></span>
        </div>
        <div class="language">
          <img src="../../assets/Norway.png"><span >Norge -<label @click="languageChoose(10,0)">English</label></span>
        </div>
        <div class="language">
          <img src="../../assets/Page 1.png">
          <span >Portugal -<label  @click="languageChoose(11,0)">English</label><label @click="languageChoose(11,11)">Portuguese</label></span>
        </div>
        <div class="language">
          <img src="../../assets/Spain.png">
          <span >España -<label @click="languageChoose(12,0)">English</label><label @click="languageChoose(12,12)">Spanish</label></span>
        </div>
        <div class="language ">
          <img src="../../assets/Sweden.png">
          <span>Sverige -<label @click="languageChoose(4,0)">English</label><label @click="languageChoose(4,4)">Sweden</label></span>
        </div>
        <div class="language">
          <img src="../../assets/Turkey.png"><span >Turkey -<label  @click="languageChoose(13,0)">English</label><label  @click="languageChoose(13,13)">Türkçe</label></span>
        </div>
        <div class="language speLang3">
          <img src="../../assets/England.png"><span>United Kingdom -<label @click="languageChoose(0,0)">English</label></span>
        </div>
        <div class="language">
          <img src="../../assets/Romania.png"><span>Romania -<label @click="languageChoose(15,0)">English</label></span>
        </div>
        <div class="language">
          <img src="../../assets/Czech republic.png">
          <span>Czech republika -<label @click="languageChoose(16,0)">English</label><label @click="languageChoose(16,16)">Czech</label></span>
        </div>
        <div class="language">
          <img src="../../assets/Slovenska republika.png"><span>Slovenska republika -<label @click="languageChoose(17,0)">English</label></span>
        </div>
        <div class="language">
          <img src="../../assets/Lithuania.png"><span>Lithuania -<label @click="languageChoose(18,0)">English</label></span>
        </div>
        <div class="language">
          <img src="../../assets/Polska.png"><span>Polska -<label @click="languageChoose(19,0)">English</label><label @click="languageChoose(19,19)">Polski</label></span>
        </div>
        <div class="language">
          <img src="../../assets/Danmark.png"><span>Danmark -<label @click="languageChoose(20,0)">English</label><label @click="languageChoose(20,20)">Dansk</label></span>
        </div>
        <div class="language">
          <img src="../../assets/Suomi.png"><span>Suomi -<label @click="languageChoose(21,0)">English</label><label @click="languageChoose(21,21)">Suomi</label></span>
        </div>
        <div class="language">
          <img src="../../assets/Switzerland.png"><span>Switzerland -<label @click="languageChoose(26,0)">English</label></span>
        </div>
        <!-- 2020-1-2 add -->
        <div class="language">
          <img src="../../assets/flags/Croatia.png"><span>Republika Hrvatska -<label @click="languageChoose(31,0)">English</label></span>
        </div>
        <div class="language">
          <img src="../../assets/flags/Austria.png"><span>Republik Österreich -<label @click="languageChoose(32,0)">English</label></span>
        </div>
        <div class="language">
          <img src="../../assets/flags/Slovenia.png"><span>Republika Slovenija -<label @click="languageChoose(33,0)">English</label></span>
        </div>
        <div class="language">
          <img src="../../assets/flags/Estonia.png"><span>Eesti Vabariik -<label @click="languageChoose(34,0)">English</label></span>
        </div>
        <div class="language">
          <img src="../../assets/flags/Latvia.png"><span>Latvijas Republika -<label @click="languageChoose(35,0)">English</label></span>
        </div>
        <div class="language">
          <img src="../../assets/flags/BIH.png"><span>Bosnia and Herzegovina -<label @click="languageChoose(36,0)">English</label></span>
        </div>
        <div class="language">
          <img src="../../assets/flags/Bulgaria.png"><span>Народна република България -<label @click="languageChoose(37,0)">English</label></span>
        </div>

        <!-- 比利时, 2020.3.16 增加 -->
        <div class="language">
          <img src="../../assets/flags/Belgium.png"><span>België -<label @click="languageChoose(39,0)">English</label></span>
        </div>
      </div>

      <div class="language-group">
        <label>{{ $t('South America') }}</label>
        <hr class="language-form-hr">
        <div class="language">
          <img src="../../assets/flags/Chile.png">
          <span >República de Chile -<label @click="languageChoose(38,0)">English</label><label @click="languageChoose(38,12)">Spanish</label></span>
        </div>
      </div>

      <div class="language-group">
        <label>{{ $t('middleEast') }}</label>
        <hr class="language-form-hr">

        <div class="language">
          <img src="../../assets/Saudi_Arabia.png"><span>Saudi -<label @click="languageChoose(27,0)">English</label></span>
        </div>

        <div class="language">
          <img src="../../assets/Uniited_Arab_Emirates.png"><span>Uniited Arab -<label @click="languageChoose(28,0)">English</label></span>
        </div>

        <div class="language">
          <img src="../../assets/Qatar.png"><span>Qatar -<label @click="languageChoose(29,0)">English</label></span>
        </div>

        <div class="language">
          <img src="../../assets/Kuwait.png"><span>Kuwait -<label @click="languageChoose(30,0)">English</label></span>
        </div>

      </div>

      <hr class="language-form-hr">
    </div>

    <!--

    <div class="language-group">
      <label>{{ $t('middleEast') }}</label>
      <hr class="language-form-hr">

    </div>-->

    <div slot="footer" class="language-choose-footer">
      <button  @click="cancelChoose" >{{ $t('Cancel') }}</button>
    </div>
  </el-dialog>
</div><!--header 结束-->
</template>

<script>
  import auth from '../../auth/auth'
  export default{
      data(){
          return{
            locale:'en',
            languageFormVisible:false,isA:true,flag:'',isB:false,dialogSize:'small',hostname:'',
            showCountry:true,
            chooseLang:'',asia:'',europe:'',
            /* GB 英国
            *  BE 比利时, 2020.3.16 增加
            *  BA  波黑
            * SK , SI 都表示斯洛文尼亚， 可能重复了, 对应的索引分别是 17 和 33  (错的)
            * SK 表示 斯洛伐克
            * SI 表示 斯洛文尼亚
            * 0 -- GB 英国
            * 1 -- CN 中国
            * 2 -- FR 法国
            * 3 -- DD 德国
            * 4 -- SE 瑞典
            * 5 -- AU 澳大利亚
            * 6 -- HKF 中国香港
            * 7 -- HU 匈牙利
            * 8 -- IT 意大利
            * 9 -- NL 荷兰
            * 10 -- Nor 挪威
            * 11 -- PT 葡萄牙
            * 12 -- ES 西班牙
            * 13 -- TR 土耳其
            * 14 -- AE 阿联酋  有重复
            * 15 -- Ro 罗马尼亚
            * 16 -- CZ 捷克
            * 17 -- SK 斯洛伐克
            * 18 -- LT 立陶宛
            * 19 -- PL 波兰
            * 20 -- DK 丹麦
            * 21 -- FI 芬兰
            * 22 -- TH 泰国
            * 23 -- ID 印度尼西亚
            * 24 -- MY 马来西亚
            * 25 -- IN 印度
            * 26 -- CH 瑞士
            * 27 -- SA 沙特
            * 28 -- AE 阿联酋
            * 29 -- QA 卡塔尔
            * 30 -- QW 科威特
            * 31 -- RH 克罗地亚
            * 32 -- AT 奥地利
            * 33 -- SI 斯洛文尼亚
            * 34 -- EE 爱沙尼亚
            * 35 -- LV 拉脱维亚
            * 36 -- BA 波黑
            * 37 -- BG 保加利亚
            * 38 -- CL 智利
            * 39 -- BE 比利时
            * */

            /*
            * 2020.6.22 目前是39个国家， 国家列表里面是40个国家， 其中有一个是重复的， 阿联酋(AE)
            *  科威特 的国家 代码 是 QW, 不是 KW
            * */
            country:['GB','CN','FR','DD','SE','AU','HKF','HU','IT','NL',   // 10个一行
                     'Nor','PT','ES','TR','AE','Ro','CZ','SK','LT','PL',   // 便于计数
                     'DK','FI','TH','ID','MY','IN','CH','SA','AE','QA',
                     'QW','RH','AT','SI','EE','LV','BA','BG','CL', 'BE'          // 2020.1.2 增加， RH 到 CL ， 共8个
            ],
        }
      },
      computed:{
        changeLanguage(){
          console.log('compute changeLanguage');
         return this.$store.state.language;
        }
      },
      watch:{
        changeLanguage(val){       // 这个属性实在computed里面定义的属性。
          this.$i18n.locale = val;
          console.log('watch changeLanguage:', val);
        }
      },
      methods:{
        //选择语言
        languageChoose(countryIndex,languageIndex){
            let info =[countryIndex,languageIndex];
           this.languageFormVisible=false;
           let country = this.country[countryIndex];
           let flag = 1;
           console.log('loc_code:', countryIndex, country);
           localStorage.setItem('loc_code', country);
           this.$store.commit('updateLocCode', country)

           /*正式版开放跳转，测试版关闭（将下列代码需注释掉）*/
           if (1) {   // 测试时关闭， 正式用时打开
             if(countryIndex===1){
                 if(this.hostname!=='cn'){
                     if(this.isA){
                       window.location = 'https://easyview.medtrum.cn/#/login?country='+country;
                     }else{
                       window.location = 'https://easyview.medtrum.cn/#/hcpLogin?country='+country;
                     }
                     flag=0;
                 }
             }
             else{
               if(this.hostname!=='eu'){
                 if(this.isA){
                   window.location = 'https://easyview.medtrum.eu/#/login?country='+country;
                 }else{
                   window.location = 'https://easyview.medtrum.eu/#/hcpLogin?country='+country;
                 }
                 flag=0;
               }
             }
           }

           info.push(flag);
          this.$store.commit('changLanguage',info);
         },
        //取消选择
        cancelChoose(){
          this.languageFormVisible=false;
        }
      },
    created(){
      auth.initLanguages(this);
    },
     mounted(){
       this.isA = (this.$route.path ==='/login'||this.$route.path ==='/sign')?true:false;
       if ('/login'==this.$route.path || '/sign'==this.$route.path) {
         this.flag='patient';
       } else if ('/accountsmanagement' == this.$route.path) {
          this.flag='accountsmanagement';
          this.showCountry = false;
       } else if ('/clinic' == this.$route.path) {
         this.flag='clinic';
         this.showCountry = false;
       } else {
         this.flag='hcp';
       }
       let win = window.innerWidth;
       this.dialogSize =(win<1850)?'large':'small';
     },
  }
</script>

<style scoped>
  .header{
    width:95%;
    height:52px;
    padding-top: 1.5%;
    margin:0 auto 4.5%;
    background-color:transparent ;
  }
  .signHeader{
    margin:1% auto 2%;
  }
  .header-left{
    float:left;
  }
  .logo{
    width:130px;
    height:52px;
    float:left;
  }
  .line{
    float:right;
    height:35px;
    margin-top:9px;
    border-right: 2px solid rgba(0,159,223,0.30);
  }
  .header-left i{
    background:rgba(0,159,223,0.30);
    width:2px;
    height:35px;
  }
  .header-left span{
    float: left;
    height: 52px;
    width:453px;
    line-height: 52px;
    font-size:26px;
    color:#2aace0;
    font-family: SFUIText-Medium;
    letter-spacing:-0.64px;
    margin-left: 16px;
    overflow: hidden;
  }
  .header-right{
    float: right;
    font-family:SFUIText-Regular;
    cursor:pointer;
  }
  .header-right span{
    font-size:22px;
    float: right;
    text-align:center;
    letter-spacing:-0.54px;
    border:none;
    background:transparent;
    margin-left:10px;
    outline: none;
    height:26px;
    line-height:26px;
    color:#282828;
  }

  /*language对话框*/
  #language-choose{
    font-family:SFUIText-Regular;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  .language-choose-title{
    float: left;
    background-image:linear-gradient(-90deg, #38bcf7 0%, #3fa1f4 100%);
    height:45px;
    line-height: 50px;
    width:100%;
    margin:-20px 30px 0 -20px;
    font-size:18px;
    color:#ffffff;
    letter-spacing:-0.43px;
    position: absolute;
  }
  .language-choose-title span{
    margin-left: 42px;
  }
  .language-choose-title img{
    float: right;
    margin-top:16px;
    cursor: pointer;
    margin-right: 10px;
  }

  .language-choose-body{
    width:100%;
    margin-top: 15px;
    font-family:SFUIText-Regular;
    font-size:16px;
    color:#282828;
    letter-spacing:-0.39px;
    text-align:left;
  }
  .language-choose-body label{
    margin-left: 22px;
  }
  .language-group{
    width:100%;
    margin-bottom: 30px;
    float: left;
  }
  .language{
    height:24px;
    width: 45%;
    margin-left: 22px;
    float: left;
    margin-top:20px ;
  }
  .language img{
    float: left;
    margin-right: 13px;
  }
  .language span {
    display: block;
    padding-top:2px;
    float: left;
  }
  .language-form-hr{
    background:#dedede;
    width:95%;
    height:1px;
    border:none;
    margin:10px 0 0 20px;
    clear: both;
  }
  .language label{
    margin-left: 10px;
    color:#55adf8;
    cursor: pointer;
    text-decoration: underline;
  }
  .zhType span{
    padding-top: 0;
  }
  /*目前语言种类较少，用来设计特殊样式*/
  .speLang,.speLang1{
    margin-right: 20%;
  }
  .speLang{
    margin-bottom: 10px;
  }
  .speLang2{
    *width: 50%;
  }
  .speLang3{
   * width: 50%;
    margin-right: 0;
  }

  .language-choose-footer{
    width:57%;
    margin-top:-16px;
    margin-bottom: 8px;
  }
  .language-choose-footer button{
    background-image:linear-gradient(-90deg, #42c3fd 0%, #55adf8 100%);
    box-shadow:0 3px 4px 0 #c6e1ff;
    color:#fff;
    margin:0 auto;
    border-radius:100px;
    width:150px;
    height:30px;
    border:none;
    outline: none;
    cursor: pointer;
  }
  @media screen and (max-width: 1500px){
    .header{
      padding-top: 1%;
      margin:0 auto 3%;
    }
  }
</style>



// WEBPACK FOOTER //
// Header.vue?5b7b31a2